import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner7.png'
import _imports_2 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4e2dc30a")

_pushScopeId("data-v-4e2dc30a")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { style: {"margin-bottom":"40px"} }
const _hoisted_4 = /*#__PURE__*/_createVNode("a", { style: {"color":"#fff","text-decoration":"none"} }, "安装包下载", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_11 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_17 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_21 = { class: "spacName" }
const _hoisted_22 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_23 = { id: "perf_report" }
const _hoisted_24 = { class: "corePerformance" }
const _hoisted_25 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试结论")
], -1)
const _hoisted_26 = { class: "spacName" }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "text_blue" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("的所有线程中")
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("UnityMain中的")
const _hoisted_33 = { key: 2 }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("UnityMain中的")
const _hoisted_35 = { class: "corePerformance" }
const _hoisted_36 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("二、详细测试数据")
], -1)
const _hoisted_37 = { class: "spacName" }
const _hoisted_38 = {
  class: "bold",
  style: {"margin-top":"8px"}
}
const _hoisted_39 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_40 = { class: "gameTable6" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createVNode("h6", { class: "bold" }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode(" 火焰图&数据 ")
], -1)
const _hoisted_44 = { class: "gameTable6" }
const _hoisted_45 = { class: "corePerformance" }
const _hoisted_46 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle bold" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、核心指标变动趋势图 ")
], -1)
const _hoisted_47 = { class: "spacName" }
const _hoisted_48 = { class: "labelStyle" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "labelStyle2" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      class: "queryReport2",
                      inline: true,
                      model: _ctx.filterList,
                      size: "mini"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, {
                          class: "iTemWidth3",
                          label: "选择日期"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              modelValue: _ctx.filterList.date,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterList.date = $event)),
                              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.date('date'))),
                              placeholder: "请选择",
                              style: {"width":"150px"}
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dateOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.date,
                                    value: item.date
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "iTemWidth3",
                          label: "测试类型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              modelValue: _ctx.filterList.type,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filterList.type = $event)),
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.date('type'))),
                              placeholder: "请选择",
                              style: {"width":"150px"}
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.report_type,
                                    label: item.chinese,
                                    value: item.report_type
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "reportName",
                          label: "测试子类型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterList.subtype,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.filterList.subtype = $event)),
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.date('subtype'))),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtypeOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.subtype,
                                    label: item.chinese,
                                    value: item.subtype
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "reportName",
                          label: "皮肤"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterList.scene,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filterList.scene = $event)),
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.date('scene'))),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sceneOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.scene_id,
                                    label: item.chinese,
                                    value: item.scene_id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "reportName",
                          label: "测试机型"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.filterList.uuid,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.filterList.uuid = $event)),
                              onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.date('device'))),
                              placeholder: "请选择"
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.deviceOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.UUID,
                                    label: item.name,
                                    value: item.UUID
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              style: {"height":"28px"},
                              onClick: _ctx.packageBtn
                            }, {
                              default: _withId(() => [
                                _hoisted_4
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"]),
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              modelValue: _ctx.filterList.id_test,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterList.id_test = $event)),
                              placeholder: "请选择",
                              onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.date('report')))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reportOptions, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id_test,
                                    label: item.report_name,
                                    value: item.id_test
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_button, {
                              class: "editBtn",
                              size: "mini",
                              onClick: _ctx.handleEdit
                            }, {
                              default: _withId(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_6, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_8
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_9,
                                _hoisted_10
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_12,
                                    _hoisted_13,
                                    _hoisted_14,
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17,
                                    _hoisted_18
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[20] || (_cache[20] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_20
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"])
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode("div", _hoisted_21, [
                    _hoisted_22
                  ], 512), [
                    [_directive_loading, _ctx.loading]
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createVNode("div", _hoisted_26, [
                        _createVNode("div", null, [
                          _createTextVNode(" 以下" + _toDisplayString(_ctx.typeName()) + "的部分模块耗时占比变化较大：", 1),
                          (JSON.stringify(_ctx.text) === '{}')
                            ? (_openBlock(), _createBlock("span", _hoisted_27, "暂无"))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.text, (item, k, i) => {
                          return (_openBlock(), _createBlock("div", { key: i }, [
                            _createTextVNode(_toDisplayString(i + 1) + "、", 1),
                            _createVNode("span", _hoisted_28, _toDisplayString("“" + k + "”"), 1),
                            (item?.thread != undefined || item?.length > 0)
                              ? (_openBlock(), _createBlock("span", _hoisted_29, [
                                  _hoisted_30,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item?.thread, (n, i) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: i,
                                      class: "text_blue"
                                    }, _toDisplayString(i === item?.thread?.length - 1 ? n : n + ","), 1))
                                  }), 128)),
                                  _createTextVNode("耗时变化" + _toDisplayString(item?.thread?.length > 0 ? "比较大." : "不大."), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item?.so != undefined || item?.length > 0)
                              ? (_openBlock(), _createBlock("span", _hoisted_31, [
                                  _hoisted_32,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item?.so, (n, i) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: i,
                                      class: "text_blue"
                                    }, _toDisplayString(i === item?.so.length - 1 ? n : n + ","), 1))
                                  }), 128)),
                                  _createTextVNode("模块耗时变化" + _toDisplayString(item.so.length > 0 ? "比较大." : "不大.") + ",", 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item?.module != undefined || item?.length > 0)
                              ? (_openBlock(), _createBlock("span", _hoisted_33, [
                                  _hoisted_34,
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item?.module, (n, i) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: i,
                                      class: "text_blue"
                                    }, _toDisplayString(i === item?.module?.length - 1 ? n : n + ","), 1))
                                  }), 128)),
                                  _createTextVNode("的耗时变化" + _toDisplayString(item?.module?.length > 0 ? "比较大." : "不大."), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("div", _hoisted_37, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableObj, (item, k, i) => {
                          return (_openBlock(), _createBlock("div", { key: i }, [
                            _createVNode("h6", _hoisted_38, [
                              _hoisted_39,
                              _createTextVNode(" " + _toDisplayString(k), 1)
                            ]),
                            _createVNode("table", _hoisted_40, [
                              _createVNode("thead", null, [
                                _createVNode("tr", null, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.head, (v, index) => {
                                    return (_openBlock(), _createBlock("td", {
                                      key: index,
                                      class: index === 0 ? 'right_no' : ''
                                    }, [
                                      _createVNode("span", {
                                        class: index === 0 ? 'margin_left' : ''
                                      }, _toDisplayString(_ctx.getHead(v.name)), 3)
                                    ], 2))
                                  }), 128))
                                ])
                              ]),
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.list, (n) => {
                                  return (_openBlock(), _createBlock("tr", { key: n }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.head, (v) => {
                                      return (_openBlock(), _createBlock("td", { key: v }, [
                                        (n.old != undefined)
                                          ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(typeof n[v.value] == "number"
                                ? _ctx.getNone(
                                    (n[v.value] * 100).toFixed(2),
                                    v.value
                                  )
                                : _ctx.getText(n[v.value])), 1))
                                          : _createCommentVNode("", true),
                                        (
                                JSON.stringify(n.old) != '{}' &&
                                n.old != undefined &&
                                typeof n?.old[v.value] == 'number'
                              )
                                          ? (_openBlock(), _createBlock("span", _hoisted_42, [
                                              (v.value == 'avg_fps')
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 0,
                                                    style: 
                                  'color:' +
                                  _ctx.getColor(
                                    _ctx.getNum(
                                      n[v.value],
                                      n?.old[v.value],
                                      v.value
                                    ),
                                    true
                                  )
                                
                                                  }, _toDisplayString(_ctx.getNum(n[v.value], n?.old[v.value], v.value)), 5))
                                                : (_openBlock(), _createBlock("span", {
                                                    key: 1,
                                                    style: 
                                  'color:' +
                                  _ctx.getColor(
                                    _ctx.getNum(
                                      n[v.value],
                                      n?.old[v.value],
                                      v.value
                                    ),
                                    false
                                  )
                                
                                                  }, _toDisplayString(_ctx.getNum(n[v.value], n?.old[v.value], v.value)), 5))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        }), 128)),
                        _withDirectives(_createVNode("div", null, [
                          _hoisted_43,
                          _createVNode("table", _hoisted_44, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imgHead, (v, index) => {
                                  return (_openBlock(), _createBlock("td", {
                                    key: index,
                                    class: index === 0 ? 'right_no' : ''
                                  }, [
                                    _createVNode("span", {
                                      class: index === 0 ? 'margin_left' : ''
                                    }, _toDisplayString(_ctx.getType(v, index)), 3)
                                  ], 2))
                                }), 128))
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pic.list, (item) => {
                                return (_openBlock(), _createBlock("tr", { key: item }, [
                                  _createVNode("td", null, [
                                    _createVNode("span", null, _toDisplayString(item.label), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      style: {"color":"#61c3e4","text-decoration":"underline"},
                                      onClick: ($event: any) => (_ctx.btn(item.flame_graph))
                                    }, "点击查看火焰图", 8, ["onClick"])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      download: "",
                                      href: item.flame_graph
                                    }, "下载链接", 8, ["href"])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      download: "",
                                      href: item.simpleperf_data
                                    }, "数据下载", 8, ["href"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ], 512), [
                          [_directive_loading, _ctx.loading]
                        ])
                      ])
                    ]),
                    _withDirectives(_createVNode("div", _hoisted_45, [
                      _hoisted_46,
                      _createVNode("div", _hoisted_47, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.trend.label, (item) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "FPStrend",
                            key: item
                          }, [
                            _createVNode(_component_el_card, null, {
                              default: _withId(() => [
                                _createVNode("p", null, [
                                  _createVNode("span", _hoisted_48, "     " + _toDisplayString(item), 1),
                                  _hoisted_49
                                ]),
                                _createVNode("div", {
                                  id: 'performance_line' + item,
                                  style: {"width":"100%","height":"350px"}
                                }, null, 8, ["id"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ])
                    ], 512), [
                      [_directive_loading, _ctx.loading]
                    ])
                  ])
                ]),
                _hoisted_50
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})